<template>
  <div class="chart pie_chart"></div>
</template>

<script>
import * as echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/map'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/visualMap'
import ChartMixin from './ChartMixin'
import worldMap from '@/assets/map/world.json'

echarts.registerMap('world', worldMap)

export default {
  name: 'MapChart',
  mixins: [
    ChartMixin
  ],
  methods: {
    getDefaultOptions () {
      return {
        legend: {
          show: false
        },
        tooltip: {
          trigger: 'item'
        },
        grid: {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        }
      }
    }
  }
}
</script>

<style lang="scss">
.line_chart {
  position: relative;
  width: 600px;
  height: 400px;
}
</style>
